document.addEventListener('DOMContentLoaded', () => {
    // Select elements with either 'animate-bg' or 'animate' class
    const elementsToAnimate = document.querySelectorAll('.animate-bg, .animate');
    
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add 'in-view' class to the element when it becomes visible in the viewport
                entry.target.classList.add('in-view');
            }
        });
    }, {
        threshold: 0.1 // Adjust this value to control when the animation triggers
    });

    // Observe each element for intersection changes
    elementsToAnimate.forEach(element => observer.observe(element));
});